import $ from 'jquery';
import config from './globals/config';
import search from './search';

let headerContainer = $('.header-container');
let trailerBtn = $('.single-trailer');
let filmTitle = $('.single-top-bg .title');

export default function () {
  function hideTrailerBtn (fadeInTime) {
    // fade tailer button in and out to avoid transition weirdness
    trailerBtn.fadeOut('fast');
    filmTitle.fadeOut('fast');

    setTimeout(function () {
      filmTitle.fadeIn('fast');

      if (config.theWindow.width() > 640 || (config.theWindow.width() <= 640 && !headerContainer.hasClass('smaller'))) {
        trailerBtn.fadeIn('fast');
      }
    }, fadeInTime);
  }

  let scrollTop = config.theWindow.scrollTop();

  if (scrollTop >= config.offsetVal) {
    if (!headerContainer.hasClass('smaller')) {
      hideTrailerBtn(500);

      setTimeout(function () {
        headerContainer.addClass('smaller');
      }, 150);
    }

  } else {
    if (headerContainer.hasClass('smaller')) {
      hideTrailerBtn(500);

      setTimeout(function () {
        headerContainer.removeClass('smaller');
      }, 150);
    }
  }

  search.onScroll();
}
